import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
const creditTypes: Record<string, string> = {
  '1': '3 hrs. Agency Law',
  '2': '3 hrs. Legal Issues',
  '3': '3 hrs. Fair Housing',
  '4': '3 hrs. Contract Law',
  '5': '3 hrs. Comm. Standards',
  '6': '3 hrs. Disclosure',
  '7': '3 hrs. General',
  '8': 'NONE',
  '9': 'Req. For Licensees'
};
export function ViewCreditType() {
  const navigate = useNavigate();
  const {
    id
  } = useParams();
  const name = id && creditTypes[id] ? creditTypes[id] : 'Agency Law';
  return <div className="space-y-4" data-id="element-2566" data-mp="3trk2dgnacmbs">
      <div className="flex items-center justify-between" data-id="element-2567" data-mp="3oszac4i6t8yf">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-2568" data-mp="3otiiiti1ciz9">Credit Type</h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/credit-types')} data-id="element-2569" data-mp="1zd9dj86oxs60">
          ← Back to Credit Types
        </Button>
      </div>

      <Card data-id="element-2570" data-mp="3jdwigc9c4vb8">
        <CardContent className="pt-6" data-id="element-2571" data-mp="3jdms2nkdom50">
          <table className="text-sm w-full max-w-sm" data-id="element-2572" data-mp="3jaidcw9ae803">
            <tbody data-id="element-2573" data-mp="3ob64rj1fgquu">
              <tr data-id="element-2574" data-mp="3oamyx0p1xsx6">
                <td className="py-2 pr-6 font-medium text-slate-700 w-24" data-id="element-2575" data-mp="3oa3dvb43uoex">
                  Name
                </td>
                <td className="py-2 text-slate-900" data-id="element-2576" data-mp="z40ozwkiqh7">{name}</td>
              </tr>
            </tbody>
          </table>

          <div className="mt-6" data-id="element-2577" data-mp="5x5k5lxwort7">
            <Button size="sm" variant="secondary" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate(`/credit-types/edit/${id}`)} data-id="element-2578" data-mp="5w3x0j3m8ev4">
              Edit
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>;
}